import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCategoryPagePaginationData } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPagePaginationData";
import { CategoryPageRequestParamsProvider } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/CategoryPageRequestParamsProvider";
import { CategoryPagePrefetcher } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/CategoryPagePrefetcher";
import { useOneIndexedPageNumber } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useOneIndexedPageNumber";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { useRefFrom } from "@faire/web--source/ui/hooks/useRefFrom";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React, { startTransition, useEffect } from "react";
import { useLocation } from "react-router-dom";
export var CategoryNextPagePrefetch = function() {
    var paginationData = useCategoryPagePaginationData();
    var oneIndexedPageNumber = useOneIndexedPageNumber();
    var _useLocation = useLocation(), pathname = _useLocation.pathname, search = _useLocation.search;
    var currentPath = "".concat(pathname).concat(search);
    var _React_useState = _sliced_to_array(React.useState(currentPath), 2), prefetchPagePath = _React_useState[0], setPrefetchPagePath = _React_useState[1];
    // give time for page to scroll to top after page change
    var debouncedSetPrefetchPagePath = useRefFrom(function() {
        return debounceIfPossible(function(path) {
            startTransition(function() {
                setPrefetchPagePath(path);
            });
        }, 1000);
    }).current;
    useEffect(function() {
        if (prefetchPagePath !== currentPath) {
            debouncedSetPrefetchPagePath(currentPath);
        }
    }, [
        prefetchPagePath,
        currentPath,
        debouncedSetPrefetchPagePath
    ]);
    var nextPageNumber = oneIndexedPageNumber + 1;
    var _paginationData_page_count;
    var isNextPageAvailable = nextPageNumber <= ((_paginationData_page_count = paginationData === null || paginationData === void 0 ? void 0 : paginationData.page_count) !== null && _paginationData_page_count !== void 0 ? _paginationData_page_count : 0) && nextPageNumber > 0;
    // prefetchPagePath !== currentPath check is used to
    // rerender WhenVisibilityIsImminent to trigger the visibility sensor again
    if (!isNextPageAvailable || prefetchPagePath !== currentPath) {
        return null;
    }
    return /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
        useTransition: true,
        threshold: 0,
        children: /*#__PURE__*/ _jsx(CategoryPageRequestParamsProvider, {
            pageNumber: nextPageNumber,
            children: /*#__PURE__*/ _jsx(CategoryPagePrefetcher, {})
        })
    });
};
